import React,{ useState, useEffect, useContext } from 'react';
import './ParentalConsent.css';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Logo from '../../assets/logo.png';
import Box from '@mui/material/Box';

//import countryData from './../../assets/countries-states-cities.json';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import loginBanner from '../../assets/parental-consent-bg.png';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
//import validator from 'validator';
import FormHelperText from '@mui/material/FormHelperText';
import { UserContext } from '../../App';
import ReactGA from 'react-ga'; 
import { addEventLog } from "./../auth/util/util";
import { appLink } from './util/CustomConstants';


function ParentalConsent(props) {


  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [mobileError, setMobileError] = useState('');
  const [gardianCheck, setGardianCheck] = useState(true);
  const [gardianCheckError, setGardianCheckError] = useState('');
  const [userEmail, setUserEmail] = useState(props.userEmail);
  const [userMobile, setUserMobile] = useState(props.userMobile);
  const [countryCode, setCountryCode] = useState(props.countryCode);
  const [skipParental, setskipParental] = useState(false);
  const [countryData,setCountryData] = useState([]);

  const profileContext = useContext(UserContext);
  useEffect(() => {
    addEventLog(0,0,'afa209c8-6ce9-44f2-a8cf-9725beb5075d','','')
    ReactGA.pageview(window.location.pathname);
    //setCountryCode(countryData[102].phone_code);
    fetch(process.env.PUBLIC_URL+`/countries-states-cities.json`)
    .then(response => response.json())
    .then(data => {
      console.log(data);
      setCountryData(data)
      setCountryCode(data[102].phone_code);
    })
    
    }, []);
  const formValidate = (data) => {
    let nameError = "";
    let emailError = "";
    let mobileError = "";
    let gardianCheckError = "";

    const regMatchFirst = /^[a-zA-Z ]*$/.test(data.get('name'));
    const regMatchLast = /^[a-zA-Z ]*$/.test(data.get('lastName'));
    let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
   

    if (data.get('name')=='') {
      nameError = "Please enter your name";
    }
    else if(!regMatchFirst)
    {
      nameError = "Please enter a valid name";
    }
    else
    {
      nameError = "";
    }
  

    if (data.get('email')=='') {
      emailError = "Please enter a valid email address";
    }
    else if(!regEmail.test(data.get('email')))
    {
      emailError = "Please enter a valid email address";
    }
    else if(data.get('email') == userEmail)
    {
      emailError = "Your email address cannot be same as that of your parent/guardian";
    }
    else
    {
      emailError = "";
    }
    
    if (data.get('mobile')=='') {
      mobileError = "Please enter a mobile number";
    }
    else if(!/^[0-9\b]+$/.test(data.get('mobile')) || data.get('mobile').length < 8)
    {
      mobileError = "Please enter a valid mobile number";
    }
    else if(data.get('mobile') == userMobile)
    {
      mobileError = "Your mobile number cannot be same as that of your parent/guardian";
    }
    else
    {
      mobileError = "";
    }

    if (gardianCheck===false) {
      gardianCheckError = "Please confirm that the details provided are of your parent/guardian";
    }
    else
    {
      gardianCheckError = "";
    }

    
    if (nameError || emailError || mobileError || gardianCheckError) {
      setNameError(nameError);
      setEmailError(emailError);
      setMobileError(mobileError);
      setGardianCheckError(gardianCheckError);
      return false;
    }
    else {
      setNameError('');
      setEmailError('');
      setMobileError('');
      setGardianCheckError('');
    }

    return true;
  }

  const handleSubmit = (event) => {
    event.preventDefault();

    const data = new FormData(event.currentTarget);
    
    let isValid = formValidate(data);
    
    if (isValid) {
      
        try {
          props.onSubmitForm(data.get('name'),data.get('email'),data.get('mobile'),false)
         
      } catch (error) {
          console.log('error signing up:', error);
          
      }
    }
  };
  const handleChangeCountryCode = (event) => {
    setCountryCode(event.target.value);
   };
 const skipParentalConsent =(event)=>
 {
    skipParental(true);
    const data = new FormData(event.currentTarget);

    try {
    props.onSkipForm(data.get('name'),data.get('email'),data.get('mobile'),true)

    } catch (error) {
    console.log('error signing up:', error);

    }
    console.log('in SKip condition',data);
 }

    return (
      <body className='loginPageBody'>
      <div className='custom_container'>

        {/* Forgot Password Page */}
        
        <Grid container spacing={2} className='loginScreen'>
          <Grid item md={6} className='formsection'>
          <Box component="form" noValidate onSubmit={handleSubmit}>
                <Link href={appLink} ><img src={Logo} title="MySphere" alt='MySphere' className='logo2'/></Link>
                <h1>Parental consent</h1>
                <p className='patentslnote'><svg viewBox="0 0 24 24" width="20" height="20" stroke="#6F6F8B" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" className="css-i6dzq1"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> Please provide your parent's/guardian's details since you are under the age of {profileContext.state.underAge}. An email will be sent to your parent/guardian for their approval.</p>
                <FormControl fullWidth className='formControl'>
                    <label>Parent's / Guardian's name*</label>
                    <TextField
                      autoComplete="none"
                      name="name"
                      required
                      fullWidth
                      id="name"
                      autoFocus
                      helperText={nameError}
                      error={!!nameError}
                    />
                </FormControl>
                <Grid container columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
                    <Grid item md={6}>
                        <FormControl fullWidth className='formControl'>
                            <label>Parent's / Guardian's email*</label>
                            <TextField
                            autoComplete= 'off'
                              required
                              fullWidth
                              id="email"
                              name="email"
                              type="email"
                              helperText={emailError}
                              error={!!emailError}
                              value={email}
                              onChange={(event)=>setEmail(event.target.value)}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item md={6}>
                  <FormControl fullWidth className='formControl'>
                    <label>Parent's / Guardian's mobile number*</label>
                    <div className="mobile_box">
                      <Select className='mobile_code'
                        autoComplete="none"
                          labelId="demo-simple-select-autowidth-label"
                          id="demo-simple-select-autowidth"
                          value={countryCode}
                          onChange={handleChangeCountryCode}
                          autoWidth
                        >
                          
                          {countryData.map((item) =>
                          <MenuItem key={item.phone_code} value={item.phone_code}>+{item.phone_code}</MenuItem>
                          )}
                        </Select>
                      <TextField className='mobile_code_number'
                        autoComplete="none"
                        required
                        fullWidth
                        id="mobile"
                        name="mobile"
                        type="tel"
                        helperText={mobileError}
                        error={!!mobileError}
                        InputProps={{
                          
                          inputMode: 'numeric', pattern: '[0-9]*'
                        }}
                        value={mobile}
                        onChange={(event)=>setMobile(event.target.value)}
                      />
                    </div>
                  </FormControl>
                </Grid>
                </Grid>
                <Grid item md={12}>
                    <FormControl fullWidth className='formControl checkbox_control'>
                        <FormControlLabel control={<Checkbox checked={gardianCheck} error={!!gardianCheckError} onChange={()=>setGardianCheck(!gardianCheck)} />} label="I confirm that above details are of my Parent / Guardian" />
                        {!!gardianCheckError && 
                        <FormHelperText className="Mui-error">{gardianCheckError}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item md={12} className='form_buttons'>
                <Button className='default_btn_border'sx={{ mr:1 }} type="button" onClick={()=>skipParentalConsent()}>Skip</Button>
                  <Button className='default_btn_border' type='submit'>Submit</Button>
                </Grid>
            </Box>
          </Grid>
          <Grid item md={6} className='bannersection'>
            <img className='loginBanner' src={loginBanner} title="Login Banner" alt='Login Banner'/>
            <p>MySphere is a career prep platform for students to create their profile and build a digital portfolio in a safe space.</p>
          </Grid>
        </Grid>

      </div>
      </body>
    );
}

export default ParentalConsent;
  